import type { CSSProperties } from "react"
import { Toaster as SonnerToaster } from "sonner"
import "./toaster.css"

function Toaster() {
  // Toast appearance is driven ENTIRELY by the root `.light`/`.dark` class:
  // the --toast-* card tokens and the inverted semantic-token scope both live
  // in theme/themes.css, and toaster.css pins the remaining sonner chrome
  // (close button, loader) to the same tokens. No `theme` prop and no
  // ThemeContext on purpose — a second mode source could disagree with the
  // CSS (it did, in Storybook), so the component stays context-free and is
  // correct wherever it mounts.
  return (
    <SonnerToaster
      position="bottom-right"
      visibleToasts={4}
      closeButton
      // `viewport-fit=cover` (index.html) lets an installed iOS app paint under
      // the home indicator, and sonner measures its bottom offset from the
      // physical edge, so a bottom-right toast lands on the indicator. Only the
      // bottom is overridden; sonner fills the other three sides with its own
      // defaults, and env() is 0 everywhere that has no inset. FUS-1196.
      offset={{ bottom: "calc(24px + env(safe-area-inset-bottom))" }}
      mobileOffset={{ bottom: "calc(16px + env(safe-area-inset-bottom))" }}
      style={
        {
          "--normal-bg": "var(--toast-bg)",
          "--normal-text": "var(--toast-text)",
          "--normal-border": "var(--toast-border)",
        } as CSSProperties
      }
    />
  )
}

export default Toaster
